import React from 'react';

import Row from "react-bootstrap/Row";


const Temp= (   ) => {


    return (
        <>

            <Row className="mb-3 text-start">
                <h1>  Sara Schenirer 2026-27  Dual Credit Course Registration  </h1>
                <h4 className="text-center">
        Registration closed on Friday, October 30th.<br/>
{/*Please visit again after that time.<br/>*/}
{/*                    Our site is temporarily down. Please check back in an hour.*/}
{/*We look forward to working with you!
                    {/*  To apply for the 2026-27 program, <a href="https://portal.sarasch.com/dual-application/" target="_blank">click here.</a><br/>*/}
{/*Registration for the  2026-2027 school year will open on Wednesday October 7, 2026.<br/>*/}
If you have any questions, reach out to Mrs. Lieba Berger at <a href="mailto:lberger@sarasch.com" target="_blank" >lberger@sarasch.com</a>.
        </h4>
            </Row>
            </>
            );
}



            export default Temp;
